import axios from '@/libs/api.request'


export const weixin_login = (data)=>{
    return axios.request({
        url: 'api_weixin/weixin_login',
        data,
        method: 'post'
    })
};
export const user_info_update = (data)=>{
    return axios.request({
        url: 'api_weixin/user_info_update',
        data,
        method: 'post'
    })
};

export const weixin_create_order = (data)=>{
    return axios.request({
        url: 'api_weixin/weixin_create_order',
        data,
        method: 'post'
    })
};
export const weixin_pay_check = (data)=>{
    return axios.request({
        url: 'api_weixin/weixin_pay_check',
        data,
        method: 'post'
    })
};
export const get_sale_order_ticket_info = (data)=>{
    return axios.request({
        url: 'api_weixin/get_sale_order_ticket_info',
        data,
        method: 'post'
    })
};
export const get_app_banner = (data)=>{
    return axios.request({
        url: 'api_weixin/get_app_banner',
        data,
        method: 'post'
    })
};
export const get_app_cs_info = (data)=>{
    return axios.request({
        url: 'api_weixin/get_app_cs_info',
        data,
        method: 'post'
    })
};
export const get_my_e_ticket_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_my_e_ticket_list',
        data,
        method: 'post'
    })
};
export const get_order_detail = (data)=>{
    return axios.request({
        url: 'api_weixin/get_order_detail',
        data,
        method: 'post'
    })
};
export const weixin_order_payment = (data)=>{
    return axios.request({
        url: 'api_weixin/weixin_order_payment',
        data,
        method: 'post'
    })
};

export const weixin_sdk_config = (data)=>{
    return axios.request({
        url: 'api_weixin/weixin_sdk_config',
        data,
        method: 'post'
    })
};

export const create_giveaway_order = (data)=>{
    return axios.request({
        url: 'api_weixin/create_giveaway_order',
        data,
        method: 'post'
    })
};

export const get_agent_statistic_data = (data)=>{
    return axios.request({
        url: 'api_weixin/get_agent_statistic_data',
        data,
        method: 'post'
    })
};

export const get_agent_commission_balance = (data)=>{
    return axios.request({
        url: 'api_weixin/get_agent_commission_balance',
        data,
        method: 'post'
    })
};

export const get_sale_order_express_info = (data)=>{
    return axios.request({
        url: 'api_weixin/get_sale_order_express_info',
        data,
        method: 'post'
    })
};
export const get_sale_order_express_status = (data)=>{
    return axios.request({
        url: 'api_weixin/get_sale_order_express_status',
        data,
        method: 'post'
    })
};
export const apply_member = (data)=>{
    return axios.request({
        url: 'api_weixin/apply_member',
        data,
        method: 'post'
    })
};

export const check_e_ticket = (data)=>{
    return axios.request({
        url: 'api_weixin/check_e_ticket',
        data,
        method: 'post'
    })
};

export const get_system_param = (data)=>{
    return axios.request({
        url: 'api_weixin/get_system_param',
        data,
        method: 'post'
    })
};
export const get_the_product_user_coupon = (data)=>{
    return axios.request({
        url: 'api_weixin/get_the_product_user_coupon',
        data,
        method: 'post'
    })
};

export const get_my_reward_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_my_reward_list',
        data,
        method: 'post'
    })
};

export const get_giveaway_link = (data)=>{
    return axios.request({
        url: 'api_weixin/get_giveaway_link',
        data,
        method: 'post'
    })
};
